import { Injectable } from '@angular/core';
import { PolicyModule } from './policy.module';

@Injectable({
  providedIn: 'root'
})
export class PolicyService {

  constructor() { }


  policyFiles: PolicyModule[] = [
    {
      name: 'Appeal Handling Procedure',
      nameAr: 'اجراء معالجة التظلمات',
      filePath: 'assets/attachments/Appeal_handling_procedure.pdf'
    },
    {
      name: 'Certification Agreement',
      nameAr: 'استمارة طلب شهادة مطابقة',
      filePath: 'assets/attachments/Certification_agreement.pdf'
    },
    {
      name: 'Certification Scheme',
      nameAr: 'نظام منح الشهادات',
      filePath: 'assets/attachments/Certification_scheme.pdf'
    },
    {
      name: 'Compliant Handling Procedure',
      nameAr: 'اجراء التعامل مع الشكاوي',
      filePath: 'assets/attachments/Compliant_procedure.pdf'
    },
    {
      name: 'Confidentiality Policy',
      nameAr: 'سياسة السرية',
      filePath: 'assets/attachments/Confidentiality_policy.pdf'
    },
    {
      name: 'Impartiality Policy',
      nameAr: 'سياسة الحياد',
      filePath: 'assets/attachments/Impartiality_policy.pdf'
    },
    {
      name: 'Nondiscriminatory Policy',
      nameAr: 'سياسة الانصاف وعدم التحيز',
      filePath: 'assets/attachments/Nondiscriminatory_policy.pdf'
    }
  ];

  getService(): PolicyModule[] {
    return this.policyFiles;
  }
}
